import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { makeThemeColor, TERTIARY } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../../../../utils/style';
import { SCREEN_HEIGHT, SCREEN_WIDTH } from '../../../../utils/sizes';
import { SIZE as ARROW_SIZE } from '../../../../navigation-arrow/navigationArrow.style';

export const defaultContext = makeDefaultStylingContext();

export const WIDTH = {
  [HD]: 600,
  [FULL_HD]: 600,
};

export const PADDING_VERTICAL = 56;

export const PADDING_HORIZONTAL = 32;

export const GAP = 32;

export const LIST_GAP = 16;

const colors = {
  backdrop: makeThemeColor(TERTIARY, 0.5),
  background: makeThemeColor(TERTIARY),
};

export const getExpandedPosition = ({ screenSize }) => SCREEN_WIDTH[screenSize] - WIDTH[screenSize];

export const getInitialStyle = ({ colorMode, screenSize } = defaultContext) => {
  const w = WIDTH[screenSize];
  const containerY = PADDING_VERTICAL + ARROW_SIZE[screenSize] + GAP;

  return {
    w: SCREEN_WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    color: colors.backdrop[colorMode],
    Container: {
      color: colors.background[colorMode],
      x: SCREEN_WIDTH[screenSize],
      w,
      h: SCREEN_HEIGHT[screenSize],
      Header: {
        x: PADDING_HORIZONTAL,
        y: PADDING_VERTICAL,
        w: w - PADDING_HORIZONTAL * 2,
      },
      List: {
        x: PADDING_HORIZONTAL,
        y: containerY,
        w: w - PADDING_HORIZONTAL * 2,
        h: SCREEN_HEIGHT[screenSize] - containerY - PADDING_VERTICAL,
        flex: {
          direction: 'column',
          justifyContent: 'center',
        },
      },
    },
  };
};
